import { Redirect, Route, useLocation } from 'react-router-dom';

import api from 'api/client';
import React from 'react';
import { userStore } from 'store/UserStore';

const CustomerRoute = ({ component: Component, ...rest }) => {
  const token = api.getToken();
  const [user, customerId] = userStore((state: any) => [
    state.user,
    state.customerId,
  ]);
  const location = useLocation();

  return (
    <Route
      {...rest}
      render={(props) =>
        token && customerId ? (
          <Component {...props} />
        ) : (
          <Redirect to={'/customers'} />
        )
      }
    />
  );
};

export default CustomerRoute;
